import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import env from "./env";
import "./styles/main.scss";
import sweetalertConfig from "./config/sweetalertConfig";

import axios from "axios";

axios.interceptors.response.use(
     async (response) => {
          // Verificar si la respuesta es exitosa
          if (response.status === 200) {
               try {
                    // Verificar si el usuario tiene un token
                    const token = localStorage.getItem("token");

                    if (token && !response.config.headers['Skip-Interceptor']) {

                        const headers = {
            
                            'Authorization': `Bearer ${token}`,
                            'Skip-Interceptor': 'true'
                        };

                        await axios.post(`${env.API_BASE_URL}profile/`, {}, { headers })
                        .then((response) => {
        
                            const { data } = response;
        
                            let user = data.user;
                            user.permissions = data.permissions
        
                            const userSerialized = JSON.stringify(user);
                            const extraDataSerialized = JSON.stringify(data.extra_data);
        
                            localStorage.setItem("user", userSerialized); // Guardar el usuario
                            localStorage.setItem("extra_data", extraDataSerialized); // Guardar campos extra del usuario
        
                        }).catch((error) => {

                            console.error('Error al actualizar los permisos:', error);
                        });
                    }
               } catch (error) {
                    console.error("Error al actualizar los permisos:", error);
               }
          }

          return response;
     },
     (error) => {
          return Promise.reject(error);
     }
);

const app = createApp(App);

// Hacer que la configuración esté disponible globalmente
app.config.globalProperties.$env = env;

app.use(sweetalertConfig);
app.use(store);
app.use(router);
app.mount("#app");
